import React, { Component } from 'react';
import { ImageboxContainer, ImageboxModal, ImageboxManager, ImageboxPanel } from 'react-imagebox';
import Highlight from 'react-highlight';

export default class Demo extends Component {

  onClickTrigger(index) {
    const content = (
      <ImageboxModal>
        <ImageboxPanel title="THE PROPERTY OF JENS BERGE, 1912. - {{http://nos.twnsnd.co/post/145310188971/the-property-of-jens-berge-1912|New Old Stock|true}}">
          <img data-src="static/THE_PROPERTY_OF_JENS_BERGE.jpg" />
        </ImageboxPanel>
        <ImageboxPanel title="THE BEATLES, BELFAST 1964. - {{https://www.flickr.com/photos/proni/18226214220/|Flickr|true}}">
          <img data-src="static/beatles.jpg" />
        </ImageboxPanel>
        <ImageboxPanel title="DUBLIN, BUT WHERE? MAIN STREET IN BLACKROCK! - {{http://nos.twnsnd.co/post/145210075959/dublin-but-where-main-street-in-blackrock|New Old Stock|true}}">
          <img data-src="static/DUBLIN_BUT_WHERE_MAIN_STREET_IN_BLACKROCK.jpg" />
        </ImageboxPanel>
      </ImageboxModal>
    )
    ImageboxManager.open({ content, index })
  }

  onClickDemo3() {
    const content = (
      <ImageboxModal>
        <ImageboxPanel title="A Grain of Sand -- {{https://www.wikiwand.com/en/William_Blake|William Blake|true}}">
          <div className="demo-third demo-grainOfSand">
            <p>
              To see a world in a grain of sand,<br/>
              And a heaven in a wild flower,<br/>
              Hold infinity in the palm of your hand,<br/>
              And eternity in an hour.
              <span className="demo-grainOfSand--name">A Grain of Sand -- William Blake</span>
            </p>
          </div>
        </ImageboxPanel>
        <ImageboxPanel title="He Wishes for the Cloths of Heaven -- {{https://www.wikiwand.com/en/W._B._Yeats|W. B. Yeats|true}}">
          <div className="demo-third demo-clothsOfHeaven">
            <p>
              Had I the heavens’ embroidered cloths,<br/>
              Enwrought with golden and silver light,<br/>
              The blue and the dim and the dark cloths<br/>
              Of night and light and the half-light,<br/>
              I would spread the cloths under your feet:<br/>
              But I, being poor, have only my dreams;<br/>
              I have spread my dreams under your feet;<br/>
              Tread softly because you tread on my dreams.
              <span className="demo-clothsOfHeaven--name">He Wishes for the Cloths of Heaven -- W. B. Yeats</span>
            </p>
          </div>
        </ImageboxPanel>
      </ImageboxModal>
    )
    ImageboxManager.open({
      content,
      config: {
        fadeOut: false,
        titleBar: {
          enable: true
        },
        lightbox: {
          clickSwitch: false,
          loop: false,
          speed: 0,
          smoothResize: false,
          fadeMode: false
        }
      }
    })
  }

  render() {
    const compatible = {
      lightbox: {
        compatible: true
      }
    }

    return (
      <div className="demo">
        <div className="demo-default">
          <div className="demo-component">
            <span className="popupbox-trigger" onClick={this.onClickTrigger.bind(this, 0)}>Click me</span>
            <ImageboxContainer { ...compatible } />
          </div>
          <div className="demo-source">
            <Highlight className="jsx"> {`
    import React, { Component } from 'react';
    import {
      ImageboxContainer,
      ImageboxModal,
      ImageboxManager,
      ImageboxPanel
    } from 'react-imagebox';

    export class Example extends Component {
      openImagebox() {
        const content = (
          <ImageboxModal>
            <ImageboxPanel title="THE PROPERTY OF JENS BERGE, 1912.">
              <img data-src="static/THE_PROPERTY_OF_JENS_BERGE.jpg" />
            </ImageboxPanel>
            <ImageboxPanel title="THE BEATLES, BELFAST 1964.">
              <img data-src="static/beatles.jpg" />
            </ImageboxPanel>
            <ImageboxPanel title="DUBLIN, BUT WHERE? MAIN STREET IN BLACKROCK!">
              <img data-src="static/DUBLIN_BUT_WHERE_MAIN_STREET_IN_BLACKROCK.jpg" />
            </ImageboxPanel>
          </ImageboxModal>
        )
        ImageboxManager.open({content})
      }

      render() {
        const defaultConfig = {
          lightbox: {
            compatible: true
          }
        }

        return (
          <div>
            <button onClick={this.openImagebox}>Click me</button>
            <ImageboxContainer {...defaultConfig} />
          </div>
        )
      }
    }
              `} </Highlight>
          </div>
        </div>

        <div className="demo-trigger">
          <div className="demo-component">
            <p className="demo-componentDescribe">or trigger from outside component ...</p>
            <ul className="lightbox-imgBtns">
              <li onClick={this.onClickTrigger.bind(this, 0)}></li>
              <li onClick={this.onClickTrigger.bind(this, 1)}></li>
              <li onClick={this.onClickTrigger.bind(this, 2)}></li>
            </ul>
          </div>

          <div className="demo-source">
            <Highlight className="jsx">{`
    constructor() {
      super();
      this.onClickTrigger = this.onClickTrigger.bind(this, 0);
    }

    onClickTrigger(index) {
      ImageboxManager.open({content, index})
    }

    // trigger
    // <a onClick={this.onClickTrigger}>Trigger</a>;
            `}</Highlight>
          </div>
        </div>

        <div className="demo-config">
          <div className="demo-component">
            <p className="demo-componentDescribe">change settings, or use inline HTML as content...</p>
            <span className="popupbox-trigger" onClick={this.onClickDemo3}>Click me</span>
          </div>
          <div className="demo-source">
            <Highlight className="jsx">{`

    openImagebox() {
      const content = (
        <ImageboxModal>
          <ImageboxPanel title="A Grain of Sand -- {{https://www.wikiwand.com/en/William_Blake|William Blake|true}}">
            <div className="demo-third demo-grainOfSand">
              <p>
                To see a world in a grain of sand,<br/>
                And a heaven in a wild flower,<br/>
                Hold infinity in the palm of your hand,<br/>
                And eternity in an hour.
                <span className="demo-grainOfSand--name">A Grain of Sand -- William Blake</span>
              </p>
            </div>
          </ImageboxPanel>
          <ImageboxPanel title="He Wishes for the Cloths of Heaven -- {{https://www.wikiwand.com/en/W._B._Yeats|W. B. Yeats|true}}">
            <div className="demo-third demo-clothsOfHeaven">
              <p>
                Had I the heavens’ embroidered cloths,<br/>
                Enwrought with golden and silver light,<br/>
                The blue and the dim and the dark cloths<br/>
                Of night and light and the half-light,<br/>
                I would spread the cloths under your feet:<br/>
                But I, being poor, have only my dreams;<br/>
                I have spread my dreams under your feet;<br/>
                Tread softly because you tread on my dreams.
                <span className="demo-clothsOfHeaven--name">He Wishes for the Cloths of Heaven -- W. B. Yeats</span>
              </p>
            </div>
          </ImageboxPanel>
        </ImageboxModal>
      )
      ImageboxManager.open({
        content,
        config: {
          fadeOut: false,
          titleBar: {
            enable: true
          },
          lightbox: {
            clickSwitch: false,
            loop: false,
            speed: 0,
            smoothResize: false,
            fadeMode: false
          }
        }
      })
    }

    render() {
      return (
        <div>
          <button onClick={this.openImagebox}>Click me</button>
          <ImageboxContainer />
        </div>
      )
    }
              `}</Highlight>
          </div>
          <div className="demo-somethingElse">
            <h2>Notes</h2>
            <ul>
              <li>Add title attribute to {'<ImageboxPanel>'} component to describe the topic.</li>
              <li>
                {'{{<url>|<text>|<boolean>}}'} can create an inline hyperlink in custom title.
                <ol>
                  <li>url: the url of hyperlink</li>
                  <li>text: link text</li>
                  <li>boolean: the target attribute. if true, it will opens the linked document in a new window or tab.</li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/demo.js